import { FC } from "react";
import { Column, Row } from "../../../../../components/containers";
import { useThemeStore } from "../../../../../stores";
import { Wrap } from "../../../../../components/containers/types";
import { IconAnimation } from "../../../../../components/animation";
import { CloseIcon, DocumentIcon } from "../../../../../assets/icons";
import { Text } from "../../../../../components/typography";
import { ChatFileUrl } from "../../../../../types/chat";
import { getExt } from "../../../../../utils";
import { HOST_CHAT_FILES } from "../../../../../api";
import { ChatBodyFooterEditingProps } from "./types";

const ChatBodyFooterEditing: FC<ChatBodyFooterEditingProps> = ({
  editingChat,
  setEditingChat,
  isSidePanel,
  delFiles,
  setDelFiles,
}) => {
  const theme = useThemeStore((s) => s.theme);

  const onDelFileClick = (file: string): void => {
    setDelFiles((prev) => {
      if (prev.includes(file)) {
        prev = prev.filter((f) => f !== file);
      } else {
        prev.push(file);
      }
      return [...prev];
    });
  };

  return editingChat ? (
    <Row
      style={{
        position: "absolute",
        bottom: "100%",
        right: 0,
        width: "calc(100% - 16px)",
        padding: 8,
        boxShadow: `0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)`,
      }}
      background={isSidePanel ? theme.overlay : theme.background}
      flexWrap={Wrap.Wrap}
      gap={20}
    >
      <IconAnimation
        Icon={CloseIcon}
        onHoverColor={theme.alert}
        className="cursor-pointer"
        onClick={() => {
          if (setEditingChat) setEditingChat(null);
        }}
      />

      <Text color={isSidePanel ? theme.textOnOverlay : theme.textOnBg}>
        درحال ویرایش پیام
      </Text>

      {(editingChat.files as ChatFileUrl[]).map((file) => {
        const ext = getExt(file.filename);
        return ext === ".png" ||
          ext === ".jpg" ||
          ext === ".jpeg" ||
          ext === ".webp" ? (
          <img
            key={file.filename}
            width={100}
            style={{
              borderRadius: 15,
              cursor: "pointer",
              opacity: delFiles.includes(file.filename) ? 0.1 : 1,
            }}
            alt={file.filename}
            src={`${HOST_CHAT_FILES}/${file.filename}`}
            onClick={() => onDelFileClick(file.filename)}
            className="transition"
          />
        ) : (
          <Column
            gap={5}
            key={file.filename}
            style={{ cursor: "pointer" }}
            props={{ onClick: () => onDelFileClick(file.filename) }}
          >
            <DocumentIcon
              width={20}
              height={20}
              color={
                delFiles.includes(file.filename)
                  ? theme.alert
                  : isSidePanel
                  ? theme.textOnOverlay
                  : theme.textOnBg
              }
              className="transition"
            />

            <Text
              color={
                delFiles.includes(file.filename)
                  ? theme.alert
                  : isSidePanel
                  ? theme.textOnOverlay
                  : theme.textOnBg
              }
              className="transition"
            >
              {file.filename}
            </Text>
          </Column>
        );
      })}
    </Row>
  ) : (
    <></>
  );
};

export default ChatBodyFooterEditing;
